import React from "react";

import AppRouteGenerator from "components/Common/AppRouteGenerator";

import CDEReviewReport from "./CDEReviewReport";
import CredentialingDashboard from "./CredentialingDashboard";
import DashboardsHome from "./Dashboards";
import MetadataReport from "./MetadataReport";
import MultiSourceExceptionProfilingReport from "./MultiSourceExceptionProfilingReport";
import ProviderManager from "./ProviderManager";
import TrustRules from "./TrustRules";
import DataExplorer from "./DataExplorer";

const Reporting = ({ features }) => {
    const CLIENT_ROUTES = {
        "Data Explorer": {
            component: DataExplorer,
            path: "data-explorer/*",
        },
        Dashboards: {
            component: DashboardsHome,
            path: "dashboards/*",
        },
        "Credentialing Edit UI": {
            component: CredentialingDashboard,
            path: "credentialing-dashboard",
        },
        "Multi-Source Exception Profiling Report": {
            component: MultiSourceExceptionProfilingReport,
            path: "multi-source-exception-profiling",
        },
        "Trust Rules": {
            component: TrustRules,
            path: "trust-rules/*",
        },
        "Provider Manager": {
            component: ProviderManager,
            path: "provider-manager",
        },
        "Metadata Report": {
            component: MetadataReport,
            path: "metadata-report",
        },
        "CDE Review Report": {
            component: CDEReviewReport,
            path: "cde-review-report",
        },
    };

    return (
        <AppRouteGenerator CLIENT_ROUTES={CLIENT_ROUTES} features={features} />
    );
};

export default Reporting;
